(function () {
    'use strict';

    angular.module('swif.interventions')
        .service('interventionsPlanningService', interventionsPlanningService);

    function interventionsPlanningService($q, $location, $uibModal, swif, interventionService, taskService, openstcResourcesService,
                                           swifOpenbaseCompanyService, AttachmentService, actionService, dataService) {
        'ngInject';

        var service = {};

        service.INTERVENTION_FIELDS = ['actions', 'id', 'name', 'state', 'tasks'];
        service.TASKS_FIELDS = [
            'actions',
            'category_id',
            'consumable_swif_id',
            'consumable_asks',
            'date_end',
            'date_start',
            'ask_id',
            'id',
            'name',
            'partner_id',
            'planned_hours',
            'project_id',
            'state',
            'service_id',
            'team_id',
            'user_id',
            'swif_id',
            'site1',
            'site_details',
            'external',
            'recurrence_id',
            'can_read_project',
            'inter_desc',
            'description'
        ];
        service.productsColorMapping = [];

        service.createBookingEvent = function(booking, eventsList) {
            let current = openstcResourcesService.current;
            let mapping = service.productsColorMapping;
            let selectedIds = [];

            // Retreive all currently selected products
            if (current.officers.length > 0) {
                selectedIds = current.officers.map(o => {
                    let p = _.find(mapping, m => m.resId === o.id);
                    if (p !== undefined) return p.productId;
                });
            } else if (current.team) {
                selectedIds = [_.find(mapping, m => m.resId === current.team.id).productId];
            } else if (current.serviceSupplier) {
                selectedIds = [_.find(mapping, m => m.resId === current.serviceSupplier.id).productId];
            } else {
                // Color mapping keys represents all products availables in this case
                selectedIds = mapping.map(m => m.productId);
            }

            // Check if the booking has one or more products present in selectedIds
            let productsIds = [];
            if (booking.resource_names.length) {
                booking.resource_names.map(res => {
                    if (_.includes(selectedIds, res[0])) {
                        productsIds.push(res[0]);
                    }
                });
            }

            // Create as many events as resources ids
            let eventTemplate = {
                title: booking.name,
                timezome: 'UTC',
                start: moment.utc(booking.checkin).toDate(),
                end: moment.utc(booking.checkout).toDate(),
                allDay: booking.whole_day,
                editable: false,
                className: 'planning-event-disabled',
                data: booking
            };

            productsIds.map(prodId => {
                let event = angular.copy(eventTemplate);
                event.id = `booking-${booking.id}-${prodId}`;
                event.color = _.find(mapping, m => m.productId === prodId).color;

                eventsList.push(event);
            });
        }

        service.resolveData = function () {
            function checkResources() {
                var resources = ['fullcalendar'];
                return swif.route.check({resources: resources});
            }
            function loadData() {
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Planning';

                var p_resources = openstcResourcesService.resolveData(data);

                data.project_type = $location.search().project_type || 'intervention';
                var p_interventions = service.createInterventions(data.project_type)
                    .then(function (collection) {
                        data.interventions = collection;
                        interventionService.currentCollection = collection;
                    });

                var p_tasks = service.createPlanningTasks().then(function (collection) {
                    data.tasks = collection;
                    taskService.currentCollection = collection;
                });
                return $q.all([
                    p_resources,
                    p_interventions,
                    p_tasks
                ]).then(function () {
                    return data;
                });
            }
            return swif.settings.initialize()
                .then(checkResources)
                .then(loadData);
        };

        service.getFullcalendar = function () {
            service.fullcalendar = swif.fullcalendar.getFullcalendar();
            return service.fullcalendar;
        };

        service.updateFullCalendar = function (calendar) {
            var settings = {};
            _.forOwn(calendar, function (value, key) {
                if (!_.isFunction(value)){
                    settings[key] = value;
                }
            });
            swif.settings.set('fullcalendar', settings);
        };

        service.createInterventions = function (project_type) {
            var filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['open']);
            swif.data.sortOn(filter, 'id', 'DESC');
            filter.fields = interventionService.COLLECTION_FIELDS;
            return swif.collections.createOrUpdate(
                'planning-interventions',
                project_type || 'intervention',
                filter,
                {limitPerPage: 8}
            );
        };

        service.createPlanningTasks = function () {
            var filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['draft']);
            swif.data.addFilter(filter, 'project_id', '=', false);
            swif.data.sortOn(filter, 'id', 'DESC');
            filter.fields = service.TASKS_FIELDS;
            return swif.collections.createOrUpdate(
                'planning-tasks',
                'task',
                filter,
                {limitPerPage: 7}
            );
        };

        service.refreshAllCollections = function () {
            swif.collections.refreshCollections([
                'planning-tasks', 'planned-tasks', 'planning-interventions'
            ]);
        };

        service.preModalIntervention = function (data) {
            swif.collections.getCollection('planning-interventions').preModal(data);
            return interventionService.preModal(data);
        };

        service.preModalTask = function (data) {
            taskService.preModal(data);
            if (data.action.id === 'add') {
                var inter = swif.collections.getCollection('planning-interventions');
                if (inter.currentItem) {
                    data.model.project_id = [inter.currentItem.id, inter.currentItem.name];
                    data.model.name = inter.currentItem.name;
                    data.model._project = inter.currentItem;
                }
            } else if (_.contains(['edit', 'copy'], data.action.id)) {
                if (data.model.id) {
                    swif.data.get('task', data.model.id, {
                        fields: taskService.COLLECTION_FIELDS
                    }).then(function (task) {
                        swif.data.updateObj(task, data.model);
                    });
                }
            }
        };

        service.preValidateTask = function (data) {
            if (data.action.id === 'print' && data.model.id === 'planned-tasks') {
                if (_.isArray(data.model._report)) {
                    data.model._report = data.model._report[0];
                }
                var ids = [];
                _.forEach(data.model.items, function (task) {
                    ids.push(task.id);
                });
                swif.data.downloadReport(
                    'task',
                    data.model._report,
                    ids,
                    data.model
                );
                return true;
            } else {
                var pre = taskService.preValidate(data);
                if (data.action.id === 'add') {
                    var model = data.model;
                    if (model._project) {
                        if (model._project.project_type === 'contract') {
                            //move site1 into site_ids because the server create task per site_ids
                            var site = model.site1;
                            if (site) {
                                model.site_ids = [site[0]];
                            }
                            delete model.site1;
                            var equipment = model.equipment_id;
                            if (equipment) {
                                model.equipment_ids = [equipment[0]];
                            }
                            delete model.equipment_id;
                        }
                    }
                    if (model.date_start && model.data_end && !model.absent_type_id) {
                        if (model.user_id || model.team_id || model.partner_id) {
                            data.model.state = 'scheduled';
                        }
                    }
                } else if (data.action.id === 'removefromplanning') {
                    taskService.removeFromPlanning(data.model);
                } else if (data.action.id === 'details') {
                    // Get all attachments
                    AttachmentService.addAttachments(data.model)
                    // Open details modal
                    var modalInstance = $uibModal.open({
                        templateUrl: 'partials/openstc/task_details_modal.html',
                        controller: 'TaskDetailsModalController',
                        size: 'lg',
                        resolve: {
                            modalParams: function () {
                                return data;
                            }
                        }
                    });
                }
                return pre;
            }
        };

        service.callbackIntervention = function (error, data) {
            // callback method for actions on planning and gantt interventions
            interventionService.callbackMessage(error, data);
            if (error) {return;}
            var interventions = swif.collections.getCollection('planning-interventions');
            interventionService.collectionCallback(interventions, data);
        };

        service.callbackTask = function (error, data) {
            // callback method for actions on planning and gantt tasks
            if (error) {return;}
            var plannedTasks = swif.collections.getCollection('planned-tasks');
            var planningTasks = swif.collections.getCollection('planning-tasks');
            var planningInterventions = swif.collections.getCollection('planning-interventions');
            //remove the task from planned-tasks
            if (plannedTasks !== undefined) {   // planned-tasks is not used on gantt view
                if (_.contains(['removefromplanning', 'notdone', 'delete'], data.action.id)) {
                    _.remove(plannedTasks.items, function (item) {
                        return item.id === data.model.id;
                    });
                }
                //update the task in planned-tasks
                if (_.contains(['edit', 'done', 'notfinished'], data.action.id)) {
                    // doesn't work so we remove item from collection and add it back
                    _.remove(plannedTasks.items, function (item) {
                        return item.id === data.model.id;
                    });
                    plannedTasks.items.push(data.model);
                }
            }
            //remove from planning-tasks
            if (data.action.id === 'delete') {
                _.remove(planningTasks.items, function (item) {
                    return item.id === data.model.id;
                });
            }
            if (data.action.id === 'addabsence') {
                data.action.id = 'add';
                taskService.collectionCallback(plannedTasks, data);
                data.action.id = 'addabsence';
            }
            if (data.action.id === 'removefromplanning') {
                planningTasks.updateItem(data.model);
            }
            if (data.action.id === 'add' && data.model.recurrence){
                swif.collections.refreshCollections(['planning-tasks', 'planned-tasks']);
            }
            taskService.collectionCallback(planningTasks, data);
            if (data.action.id === 'copy') {
                // Set id on model
                data.model.id = data.result.result;

                //Impossible to know if the task should be in the planning
                if (plannedTasks !== undefined) {
                    plannedTasks.getItems();
                }
                if (data.model.project_id && planningInterventions.currentItem) {
                    if (data.model.project_id[0] === planningInterventions.currentItem.id) {
                        planningTasks.updateItem(data.model);
                    } else {
                        planningTasks.removeItem(data.model);
                    }
                } else {
                    planningTasks.removeItem(data.model);
                }
            }
            //update inter
            if (data.model.project_id) {
                _.forEach(planningInterventions.items, function (inter) {
                    if (inter.id === data.model.project_id[0]) {
                        planningInterventions.updateItem(inter);
                    }
                });
            }
            taskService.callbackMessage(error, data);
        };

        service.userColor = openstcResourcesService.userColor;

        service.teamColor = openstcResourcesService.teamColor;

        service.getColor = function (task) {
            if (!task) {
                return '#000';
            }
            if (service.fullcalendar.baseColorOnResource) {
                if (task.user_id && service.userColor[task.user_id[0]]) {
                    return service.userColor[task.user_id[0]];
                } else if (task.team_id && service.teamColor[task.team_id[0]]) {
                    return service.teamColor[task.team_id[0]];
                }
            }
            var tasksStates = swif.settings.getContentType('task').states;
            return tasksStates[task.state].color;
        };

        service.getEventFromTask = function (task) {
            if (!task.date_start || !task.date_end) {
                return;
            }
            var ds = swif.date.formatDatetime(task.date_start, 'YYYY-MM-DD HH:mm:00');
            var de = swif.date.formatDatetime(task.date_end, 'YYYY-MM-DD HH:mm:00');
            var ms = moment(ds);
            var me = moment(de);
            var delta = moment.duration(me - ms);
            var allDay = false;
            var start = ms.toDate();
            var end = me.toDate();
            if (delta.days() > 0 && delta.hours() == 0 && ms.hours() == 0) {
                allDay = true;
                if (me.hour() === 0 && me.minute() === 0) {
                    end = me.toDate();
                } else  {
                    end = me.add(1, 'days').startOf('day').toDate();
                }
            }

            return {
                id: task.id,
                title: task.external ? task.name : '[' + task.swif_id + '] ' + task.name,
                timezone: 'UTC',
                start: start,
                end: end,
                allDay: allDay,
                color: service.getColor(task),
                data: task,
                editable: (task.actions.indexOf('update') !== -1) && (! task.external)
            };
        };


        service.getTaskFromEvent = function (tasks, event) {
            var currentTask;
            //var plannedTasks = collections.getCollection('planned-tasks');
            _.forEach(tasks, function (task) {
                if (event.id === task.id) {
                    currentTask = task;
                }
            });
            return currentTask;
        };

        service.updateTaskFromEvent = function (task, event) {
            //event.timezone === 'UTC';
            if (event.start) {
                task.date_start = swif.date.fixPlanningTZ(event.start).format('YYYY-MM-DD HH:mm:00');
            }
            if (event.end) {
                task.date_end = swif.date.fixPlanningTZ(event.end).format('YYYY-MM-DD HH:mm:00');
            } else {
                //initialize date_end
                task.date_end = moment.utc(task.date_start).add(2, 'hours').format('YYYY-MM-DD HH:mm:00');
            }
            if (event.end && event.start) {
                task.planned_hours = moment.duration(event.end.diff(event.start)).asHours();
            } else if (event.start && !event.end) {
                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                    task.planned_hours = company.task_default_hours;
                });
            }
        };

        service.updateFilter = function (filter, options) {
            //assert i have a date start, date end and a resource
            if (_.keys(options).length < 3) {
                return;
            }
            var format = 'YYYY-MM-DD 00:00:00';
            var start = options.start;
            var end = options.end;
            var ids = [];
            swif.data.resetExtraFilter(filter, 'ui');
            //remove patrimoine tasks (occurrence)
            if (swif.module.modules.openstc_patrimoine) {
                swif.data.addExtraFilter(filter, 'ui', 'site_ids', '=', false);
                // We don't want to display task with equipment of an occurence, but inter and ask alone still needs to be
                // displayed
                swif.data.addExtraFilter(filter, 'ui', '|');
                swif.data.addExtraFilter(filter, 'ui', '|');
                swif.data.addExtraFilter(filter, 'ui', 'equipment_ids', '=', false);
                swif.data.addExtraFilter(filter, 'ui', 'project_id', '=', false);
                swif.data.addExtraFilter(filter, 'ui', 'project_id.project_type', '!=', 'contract');
            }
            if (start) {
                swif.data.addExtraFilter(filter, 'ui', 'date_end', '>', start.format(format));
            }
            if (end) {
                swif.data.addExtraFilter(filter, 'ui', 'date_start', '<', end.format(format));
            }
            if (!_.isEmpty(options.officers)) {
                ids = [];
                _.forEach(options.officers, function (o) {
                    ids.push(o.id);
                });
                swif.data.addExtraFilter(filter, 'ui', '|');
                if (options.allOfficers) {
                    swif.data.addExtraFilter(filter, 'ui', '|');
                    swif.data.addExtraFilter(filter, 'ui', '&');
                    swif.data.addExtraFilter(filter, 'ui', '&');
                    swif.data.addExtraFilter(
                        filter, 'ui', 'user_id', 'in', false
                    );
                    swif.data.addExtraFilter(
                        filter, 'ui', 'team_id', 'in', false
                    );
                    swif.data.addExtraFilter(
                        filter, 'ui', 'partner_id', 'in', false
                    );

                }
                swif.data.addExtraFilter(
                    filter, 'ui', 'user_id.id', 'in', ids
                );
                swif.data.addExtraFilter(
                    filter, 'ui', 'team_id.user_ids.id', 'in', ids
                );
            } else if (options.team) {
                ids = [];
                if (_.isArray(options.team)) {
                    _.forEach(options.team, function (team) {
                        ids.push(team.id);
                    });
                } else {
                    ids.push(options.team.id);
                }
                swif.data.addExtraFilter(filter, 'ui', '|');
                swif.data.addExtraFilter(filter, 'ui', 'team_id.id', 'in', ids);
                swif.data.addExtraFilter(filter, 'ui', 'user_id.team_ids.id', 'in', ids);
            } else if (options.serviceSupplier) {
                ids = [];
                if (_.isArray(options.serviceSupplier)) {
                    _.forEach(options.serviceSupplier, function (service) {
                        ids.push(service.id);
                    });
                } else {
                    ids.push(options.serviceSupplier.id);
                }
                swif.data.addExtraFilter(filter, 'ui', 'partner_id.id', 'in', ids);
            }
            // user can only see task from their services
            var user = swif.user.getAuthenticatedUserData();
            swif.data.addExtraFilter(filter, 'ui', 'service_id.id', 'in', user.service_ids);
            return filter;
        };

        service.getTasksForOfficers = function (task, officers, task_type) {
            var tasks = [];
            task.team_id = false;
            task.partner_id = false;
            var copy;
            _.forEach(officers, function (officer) {
                copy = Object.assign({}, task);
                copy.user_id = [officer.id, officer.complete_name];

                if(task_type === 'absence' && officer.service_id) {
                    copy.service_id = officer.service_id;
                }
                delete copy.id;
                copy._filters = taskService.getFilters(copy);
                if (copy.planning) {
                    copy._multiple = []
                    copy = taskService.fillPlanningTask(copy);
                    // if fillPlanningTask currently add many task, add them to task array to save
                    if (copy._multiple.length > 0) {
                        for(const t of copy._multiple) {
                            tasks.push(Object.assign({}, t))
                        }
                    }
                }
                tasks.push(copy);
            });
            return tasks;
        };

        service.createTask = function (droppedTask) {
            var resetStates = ['done', 'cancelled'];
            if (_.contains(resetStates, droppedTask.state)) {
                droppedTask.state = 'open';
            }
            return swif.data.create('task', droppedTask);
        };

        service.saveTask = function (droppedTask) {
            return swif.data.save(
                'task',
                droppedTask.id,
                {
                    date_start: droppedTask.date_start,
                    date_end: droppedTask.date_end,
                    user_id: droppedTask.user_id,
                    team_id: droppedTask.team_id,
                    partner_id: droppedTask.partner_id,
                    category_id: droppedTask.category_id,
                    service_id: droppedTask.service_id
                }
            );
        };

        service.saveAndCreateTasks = function (tasks) {
            var promises = [];
            _.forEach(tasks, function (task) {
                if (task.id) {
                    promises.push(service.saveTask(task));
                } else {
                    promises.push(service.createTask(task));
                }
            });
            return $q.all(promises);
        };

        /**
         * Pre-validate function called by the modal before opening.
         * Called when a tasks is assigned to multiple officers
         *
         * Side effect : modify data.model.kwargs.tasks with sanitizard task data
         *
         * @param {object} data The data sent to the modal
         */
        function prevalidateMultiTaskAssign(data) {
            var promises = [];
            var sanitizedTasks = [];

            var promise; // temp variable for sanitize promise
            var isValidated;
            // Prevalidate all tasks individualy then sanitize them and push the sanitized task
            // data into the 'kwargs' for further processing so the generated request is valid

            // If multiple task, get edited attribute from uniqTasks and apply them to all tasks that will be saved
            if(data.model.kwargs.isMultipleTaskForOneUser) {
                // Remove task that are not anymore to save
                var leavingUserId = _.map(data.model.kwargs.tasks, 'user_id[0]')
                _.remove(data.model.kwargs.multipleTasks, (o) => {return !leavingUserId.includes(o.user_id[0])})


                for(const uTask of data.model.kwargs.tasks) {
                    for(const mTask of data.model.kwargs.multipleTasks) {
                        if(uTask.user_id[0] === mTask.user_id[0]) {
                            mTask.name = uTask.name;
                            mTask.service_id = uTask.service_id;
                            mTask.category_id = uTask.category_id;
                        }
                        mTask.project_id = data.model.task.project_id;
                    }
                }
                data.model.kwargs.tasks = data.model.kwargs.multipleTasks;
            }
            delete data.model.kwargs.multipleTasks;
            delete data.model.kwargs.isMultipleTaskForOneUser;
            for(const task of data.model.kwargs.tasks) {
                // Handle and resolve promise
                promise = dataService.sanitizeData("task", task, data.action.http.fields)
                    .then(function(sanitizedTask) {
                        sanitizedTasks.push(sanitizedTask);
                        return true;
                    })
                    .catch(function(error) {
                        console.err(error);
                        return false;
                    });
                promises.push(promise);
            };

            return $q.all(promises).then(function(arePreValidated) {
                var areAllPrevalidated = true;
                _.forEach(arePreValidated, function (isPrevalidated) {
                    areAllPrevalidated = areAllPrevalidated && isPrevalidated;
                });
                if (areAllPrevalidated) {
                    data.model.kwargs.tasks = sanitizedTasks;
                }
                return areAllPrevalidated;
            }).catch(function(error) {
                console.err(error);
                return false;
            });
        }

        service.assignTaskToMultipleOfficers = function (data, officers, $scope) {
            var data_assign;
            if (typeof data.model != 'undefined'){
                data_assign = data.model;
            }else {
                data_assign = data;
            }
            data_assign.available = true;
            var droppedTask = data_assign;
            var droppedTasks = service.getTasksForOfficers(droppedTask, officers);
            // Check if there is multiple task for one user
            var isMultipleTaskForOneUser = _.reduce(_.countBy(droppedTasks, (o) => {o.user_id})) > 1
            var uniqTasks = droppedTasks.map(function(value){value = Object.assign({}, value);return value});
            if (isMultipleTaskForOneUser) {
                uniqTasks = _.uniq(uniqTasks, (o) => {return o.user_id[0]})
            }

            var act = actionService.getActionById("task", "list" ,"assign_multi", data_assign);
            // The action calls 'call_kw' endpoint, hence the data structure
            var actionData = {
                task: droppedTask,
                kwargs: {
                    tasks: uniqTasks,
                    multipleTasks: droppedTasks,
                    isMultipleTaskForOneUser
                }
            }

            var onMultiAssignSuccess = function (modalParams) {
                // TG3902 - delete original task when drag & dropping a task for multiple agents
                if (modalParams.task.id) {
                    return swif.data.unlink('task', [modalParams.task.id]);
                } else {
                    return false;
                }
            };
            var modalInstance = swif.modal.open({
                title: 'Assigner la tâche à plusieurs agents',
                templateUrl: 'partials/openstc/planning_drop_task_multi_officers.html',
                action: act,
                model: actionData,
                contentType: "task",
                scope: $scope,
                preValidate: prevalidateMultiTaskAssign,
                droppedTask: droppedTask,
                droppedTasks: uniqTasks
            });
            return modalInstance.result.then(onMultiAssignSuccess);
        };

        service.assignAbsenceToMultipleOfficers = function (droppedTask, officers, $scope) {
            var droppedTasks = service.getTasksForOfficers(droppedTask, officers, 'absence');
            var modalInstance = swif.modal.open({
                title: 'Assigner la tâche à plusieurs agents',
                templateUrl: 'partials/openstc/planning_absence_multi_officers.html',
                scope: $scope,
                droppedTask: droppedTask,
                droppedTasks: droppedTasks
            });
            var onModalClosed = function (modalParams) {
                //assure that the first is the only one to have stuff
                if (modalParams.droppedTasks.length > 0) {
                    modalParams.droppedTasks[0].id = droppedTask.id;
                }
                return service.saveAndCreateTasks(modalParams.droppedTasks);
            };
            return modalInstance.result.then(onModalClosed);
        };

        service.print = {
            displayMode: 'tablebyagentbyday',
            displayTaskFields: {
                horaire: true,
                planned_hours: true,
                requester: true,
                site1: true
            }
        };

        return service;
    }

})();
